module.exports = __webpack_public_path__ + "img/icon-header-map.b23cb973.svg";